import { createRootRoute, Outlet } from '@tanstack/react-router';
import { ErrorBoundaryFallback } from '@/app/ErrorBoundary';
import { NotFound } from '@/app/NotFound';

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: ErrorBoundaryFallback,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return <Outlet />;
}
